import { Injectable, inject } from '@angular/core'
import { MatDialog } from '@angular/material/dialog'
import { Observable } from 'rxjs'
import { filter, map } from 'rxjs/operators'
import { ProdOrder } from '../prod-order'
import { ProdOrderCommand, ProdOrderCommandResult } from './prod-order-command'
import {
  IProdOrderCommandBatchDialogOptions,
  ProdOrderCommandBatchDialogComponent,
} from './prod-order-command-batch-dialog/prod-order-command-batch-dialog.component'
import { ProdOrderCommandDialogResponse } from './ProdOrderCommandDialogResponse'

@Injectable({
  providedIn: 'root',
})
export class ProdOrderCommandService {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/

  private readonly dialog = inject(MatDialog)

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public openBatchCommands(orders: ProdOrder[]): Observable<ProdOrderCommandResult[]> {
    return this.openCommandBatchDialog({
      orders: orders,
    }).pipe(
      filter((responses) => !!responses),
      map((responses) => responses.map((r) => r.result)),
      filter((result) => !!result)
    )
  }

  /***************************************************************************
   *                                                                         *
   * Private methods                                                         *
   *                                                                         *
   **************************************************************************/

  private openCommandBatchDialog(
    batchOptions: IProdOrderCommandBatchDialogOptions
  ): Observable<ProdOrderCommandDialogResponse[]> {
    const dialogRef = this.dialog.open(ProdOrderCommandBatchDialogComponent, {
      width: '80vw',
      height: '80vh',
      data: batchOptions,
    })
    return dialogRef.afterClosed().pipe(map((r) => r as ProdOrderCommandDialogResponse[]))
  }
}
